<template>
    <b-modal
        :title="$t('history.modal.header.ChangeShipDate')"
        ref="changeShipDate-modal"
        @ok="changeShipDate"
    >
        <form ref="form">
            <b-form-group
                label-cols-sm="4"
                :label="$t('history.label.NewShipDate')"
                label-align-sm="left"
            >
                <b-input-group size="sm">
                    <b-col sm="10" class="shipDatePicker">
                        <Datepicker
                            v-model="shipDate"
                            input-class="form-control form-control-sm"
                            name="shipDatePicker"
                            :disabled-dates="disabledDates"
                            :monday-first="true"
                            :typeable="false"
                        />
                    </b-col>
                </b-input-group>
            </b-form-group>
        </form>

        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button @click="cancel()">
                Cancel
            </b-button>
            <b-button @click="ok()" name="changeShipDateModalButton" variant="primary">
                {{ $t('history.modal.button.Change') }}
            </b-button>
        </template>
    </b-modal>
</template>
<script>
import { CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX } from '@/store/constants';
import helpers from '@/helper';
import Datepicker from 'vuejs-datepicker';
import { format, subDays } from 'date-fns';

export default {
    components: {
        Datepicker
    },

    props: {
        shipment: { type: Object, required: true }
    },

    data() {
        return {
            shipDate: new Date(),
            disabledDates: {
                days: [6, 0]
            }
        };
    },

    created() {
        this.disabledDates.to = subDays(new Date(), 1);
    },

    methods: {
        showChangeShipDateModal() {
            this.$refs['changeShipDate-modal'].show();
        },

        changeShipDate() {
            let obj = { shipment: this.shipment, shipDate: format(this.shipDate, 'yyyy/MM/dd') };

            this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.UPDATE_SHIP_DATE, obj);

            this.shipment.shipDate = format(this.shipDate, 'yyyy-MM-dd');
        }
    }
};
</script>

<style></style>
